module.exports = __webpack_public_path__ + "static/img/3_5_1.70f76d55.jpg";